var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserAvatar = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40.498,
    viewBox: "0 0 40 40.498",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39834",
    "data-name": "Group 39834",
    transform: "translate(-281 -564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1_copy_12",
    "data-name": "Ellipse 1 copy 12",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(281 564)",
    fill: "#f5f8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    "data-name": "Intersection 3",
    d: "M0,27.229a7.937,7.937,0,0,1,1.1-2.405c.828-1.107,4.926-2.62,7.071-3.414.367-.139.683-.256.916-.348a2.557,2.557,0,0,0,.387-.172,16.765,16.765,0,0,0,1.279-1.567h.067V18.178a9.161,9.161,0,0,1-1.492-2.169,7.647,7.647,0,0,1-.4-1.885c-1.29-.589-1.448-2.647-1.5-3.8-.027-.562.242-.612.545-.5a5.184,5.184,0,0,1-.737-1.5A7.819,7.819,0,0,1,7.04,4.982a3.1,3.1,0,0,1,.748-1.858A1.3,1.3,0,0,1,9.605,3.06,2.63,2.63,0,0,1,11.1.639,7.794,7.794,0,0,1,14.053.066c1.8-.114,3.727-.2,5.256.758a5.728,5.728,0,0,1,2.374,5.017,10.869,10.869,0,0,1-.815,3.674c-.01.1-.017.209-.027.316.313-.128.6-.094.576.488-.054,1.157-.209,3.223-1.505,3.809a10.934,10.934,0,0,1-.411,1.881,9.2,9.2,0,0,1-1.482,2.155v1.159h.067a16.75,16.75,0,0,0,1.28,1.567c.168.092.555.237,1.286.509,2.138.795,6.259,2.313,7.088,3.425a7.543,7.543,0,0,1,1.024,2.163A20,20,0,0,1,0,27.229Z",
    transform: "translate(286.736 570.787)",
    fill: "#808cac",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserAvatar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-avatar.7e015c81.svg";
export { ForwardRef as ReactComponent };